<app-page [size]="PageSize.SINGLE">
  @if (registrationCompleted) {
    <app-card>
      <div class="text-success text-xl font-semibold">
        Bitte folgen Sie dem Link in der E-Mail, die Sie soeben erhalten haben.
      </div>
    </app-card>
  } @else {
    <div>
      <h2 class="text-xl font-semibold text-{{ legalEntity.vehicleBrand.color }}">Einwilligungserklärung abgeben</h2>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col mt-5 gap-8">
        <app-select
          formControlName="customerType"
          [options]="customerTypes"
          [label]="'Privatkunde/Geschäftskunde'"
        />

        @if (showUst) {
          <app-text-input
            class="w-full"
            formControlName="ust"
            [label]="'USt-IdNr.'"
          />
        }

        @if (showCompanyName) {
          <app-text-input
            class="w-full"
            formControlName="companyName"
            [label]="'Firmenname'"
          />
        }

        <!-- Name Inputs -->
        @if (showNameInput) {
          <div class="flex flex-col sm:flex-row sm:flex-wrap md:flex-nowrap gap-4 w-full">
            <app-select
              class="w-full sm:w-[48%] md:flex-1 md:max-w-[13%]"
              formControlName="salutation"
              [options]="salutations"
              [label]="'Anrede'"
            />

            <app-text-input
              class="w-full sm:w-[48%] md:flex-1 md:max-w-[13%]"
              formControlName="title"
              [label]="'Titel'"
            />

            <app-text-input
              class="w-full sm:w-[48%] md:flex-1 md:max-w-[37%]"
              formControlName="firstName"
              [label]="'Vorname (erforderlich)'"
              [placeholder]="'Vorname'"
              [isValid]="isControlValid('firstName')"
              [errorMessage]="'Erforderlich'"
            />

            <app-text-input
              class="w-full sm:w-[48%] md:flex-1 md:max-w-[37%]"
              formControlName="lastName"
              [label]="'Nachname (erforderlich)'"
              [placeholder]="'Nachname'"
              [isValid]="isControlValid('lastName')"
              [errorMessage]="'Erforderlich'"
            />
          </div>
        }

        <!-- Address -->
        <div class="flex flex-col sm:flex-row sm:flex-wrap md:flex-nowrap gap-4 w-full">
          <app-text-input
            class="w-full sm:w-[48%] md:flex-1 md:max-w-[55%]"
            formControlName="street"
            [label]="'Straße, Hausnummer'"
          />
          <app-text-input
            class="w-full sm:w-[48%] md:flex-1 md:max-w-[15%]"
            formControlName="postcode"
            [label]="'PLZ'"
          />
          <app-text-input
            class="w-full sm:w-[48%] md:flex-1 md:max-w-[30%]"
            formControlName="city"
            [label]="'Ort'"
          />
        </div>

        <!-- Phones -->
        <div class="flex flex-col sm:flex-row sm:flex-wrap md:flex-nowrap gap-4 w-full">
          @if (showPhoneHome) {
            <app-text-input
              class="w-full sm:w-[48%] md:flex-1"
              formControlName="phoneHome"
              [label]="'Telefon Privat'"
            />
          }

          <app-text-input
            class="w-full sm:w-[48%] md:flex-1"
            formControlName="phoneOffice"
            [label]="'Telefon Büro'"
          />

          <app-text-input
            class="w-full sm:w-[48%] md:flex-1"
            formControlName="phoneMobile"
            [label]="'Mobiltelefon'"
          />
        </div>

        <app-email-input
          class="w-full"
          formControlName="email"
          [label]="'E-Mail (erforderlich)'"
          [placeholder]="'E-Mail'"
          [isValid]="isControlValid('email')"
          [errorMessage]="emailErrorMessage"
        />

        <app-registration-preferred-dealer
          [allDealerList]="allDealerList"
          [selectedDealer]="preferredDealer"
          (dealerSelected)="onDealerSelected($event)"
          class="w-full"
        />

        <app-registration-consent
          [legalEntity]="legalEntity"
          [consentVersion]="consentVersion"
        />

        <div class="text-lighterText">
          Die Datenschutzinformation zur Verarbeitung Ihrer personenbezogenen Daten finden Sie
          <a class="underline text-black" [href]="legalEntity.dsiLink(undefined)" target="_blank">
            hier
          </a>
          .
        </div>

        <div class="flex justify-center items-center">
          <button
            class="disabled:bg-lighterText w-full sm:w-1/2 md:w-1/3 px-5 py-3 rounded-xl text-sm font-semibold text-white items-center"
            [ngClass]="
            legalEntity.vehicleBrand.isLexus()
              ? 'bg-lexusBlue hover:bg-lexusBlueDark'
              : 'bg-toyotaRed hover:bg-toyotaRedDark'
            "
            [disabled]="!form.valid || registrationInProgress"
            id="submit-button"
            type="submit"
          >
            @if (registrationInProgress) {
              <app-activity-spinner></app-activity-spinner>
            }
            Anmelden
          </button>
        </div>
      </form>
    </div>
  }
</app-page>
